import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { DataUtils } from "../../common/views/DataUtils";
import { RouteUtils } from "../../common/views/RouteUtils";
import {
    AccountConfirmModel, AccountModel, AuthTokensInfo, ResetPasswordModel
} from "../models/AccountTypes";
import { AccountByService } from "../services/AccountService";

export function useConfirmAccountVM(isForgotPassword: boolean) {
    const emailAccountService = new AccountByService(true);
    const phoneAccountService = new AccountByService(false);

    const [loading, setLoading] = useState(false);
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [counter, setCounter] = useState(30);
    const [lastByEmail, setLastByEmail] = useState(false);

    const { form, setField, errorMessages,
        summaryText, summaryType
    } = useForm<AccountConfirmModel>({
        userId: "",
        isConfirmed: false,
        options: [],
        code: "",
        password: ""
    });

    const resendCode = (isByEmail: boolean) => {
        const account: AccountModel = {
            userId: form.userId,
            options: form.options,
            isConfirmed: false
        };

        sendCode(account, isByEmail);
    }

    const sendCode = (account: AccountModel, isByEmail: boolean) => {
        setLoading(true);
        setLastByEmail(isByEmail);

        setField("userId", account.userId);
        setField("options", account.options);
        setField("code", "");

        const service = isByEmail ? emailAccountService : phoneAccountService;
        const request = isForgotPassword ?
            service.sendForgotPasswordCode(account.userId) :
            service.SendConfirmCode(account.userId);

        DataUtils.onRequest(request, onSendCodeResult);
    }

    const onSendCodeResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success) {
            setCounter(30);
        }

        setLoading(false);
    }

    const confirm = (isByEmail: boolean) => {
        setLoading(true);

        const service = isByEmail ? emailAccountService : phoneAccountService;
        const request = isForgotPassword ?
            service.confirmForgotPassword(form) :
            service.confirm(form);

        DataUtils.onRequest(request, onConfirmMainResult);
    }

    const onConfirmMainResult = (result: IDataResult) => {
        setLoading(false);

        if (isForgotPassword) {
            onConfirmForgotPasswordResult(result);
        } else {
            onConfirmResult(result);
        }
    }

    const onConfirmForgotPasswordResult = (result: IDataResult) => {
        const account = result.data as ResetPasswordModel;

        if (result.status === ResponseStatus.success && account != null) {
            setField("userId", account.userId);
            setField("code", account.code);
            setShowResetPassword(true);
        } else {
            onConfirmFail();
        }
    }

    const onConfirmResult = (result: IDataResult) => {
        const account = result.data as AuthTokensInfo;

        if (result.status === ResponseStatus.success && account != null) {
            onConfirmSuccess(account);
        } else {
            onConfirmFail();
        }
    }

    const onConfirmSuccess = (account: AuthTokensInfo) => {
        RouteUtils.onLoggedIn(account);
    }

    const onConfirmFail = () => {
        RouteUtils.onLoggedOut();
    }

    return {
        errorMessages,
        summaryText,
        summaryType,
        form,
        setField,

        loading, setLoading,
        showResetPassword, setShowResetPassword,
        counter, setCounter,
        lastByEmail, setLastByEmail,

        resendCode,
        sendCode,
        confirm
    }
}